import Switcher from '../../control/Switcher'

const IncludeForStats = (props) => (
  <div className='form-group'>
    <Switcher
      on={props.enable}
      onChange={() => props.onUpdate(!props.enable)} />
    <div>
      <label>Activity contributes towards user statistics and ranks</label>
      <div>User activity in this forum is included in the user statistics, and used to unlock ranks</div>
    </div>
  </div>
)

export default IncludeForStats
